import React from "react";
import FrecciaIndietro from "../../commons/FrecciaIndietro";
import Space from "../../commons/Space";
import locandina from "../../images/Evidenza/Manutenzione_2.png"
import TitoloSezioni from "../../commons/TitoloSezioni";
import "./NewsPagesFoto.css"
import ScrollToTopOnMount from "../../components/ScrollToTopOnMount";
import Spa from "../Spa";
import SpaceL from "../../commons/SpaceL";


function Manutenzione () {
    return(
        <div className="text-center">
            <ScrollToTopOnMount />
            <FrecciaIndietro indirizzo={"/news"} />
            <p className="text-center" style={{ fontSize: "22px", fontFamily: "Hammersmith One" }}>{""}</p>
            <div className="container-foto-news m-auto d-none d-sm-block " style={{display: "flex", flexDirection: "column", width: "40%"}}>
                <img src={locandina} style={{width: "100%"}}/>
                <Space />
                <p style={{fontSize: "24px"}}>
                    Per informazioni contattare Emilio
                    <br/>
                    cell: <span/><a style={{color: "grey"}} href="tel:3482200540">348 2200540</a>
                </p>
            </div>
            <div className="container-foto-news m-auto d-sm-none" style={{display: "flex", flexDirection: "column", width: "70%"}}>
                <img src={locandina} style={{width: "100%"}}/>
                <SpaceL />
                <p style={{fontSize: "20px"}}>
                    Per informazioni contattare Emilio
                    <br/>
                    cell: <span/><a style={{color: "grey"}} href="tel:3482200540">348 2200540</a>
                </p>
            </div>
            <Space />

        </div>
    )
}
export default Manutenzione